// MD: «dar ekran» (telefon: tarayıcı + uygulama) tek yerde tanımlı — max-width 639px, Tailwind
// `sm` kırılımının altı. Bileşenler reaktif `darEkranDurum.dar`'ı okur; CSS tarafı `max-sm:`.
import { reactive } from "vue";

const SORGU = "(max-width: 639px)";
const mq = typeof window !== "undefined" && window.matchMedia ? window.matchMedia(SORGU) : null;

export const darEkranDurum = reactive({ dar: !!(mq && mq.matches) });

if (mq) {
  const guncelle = (e) => { darEkranDurum.dar = e.matches; };
  if (mq.addEventListener) mq.addEventListener("change", guncelle);
  else if (mq.addListener) mq.addListener(guncelle); // eski Safari
}

export function darEkran() {
  return darEkranDurum.dar;
}
